import { getUserData, wait } from "@/utils";
import constants from "@/constants";
import { FetcherOptionsType } from "./types";
import { AnyObject } from "@/types/Any";

const { DEFAULT_RETRIES } = constants;

export async function fetcher<T>(
  // eslint-disable-next-line @typescript-eslint/ban-types
  fetch: Function,
  url: string,
  requestConfig: RequestInit = {
    method: "GET",
    body: null,
    headers: {},
  },
  otherOptions: FetcherOptionsType = {
    passCodeRequired: true,
    returnOnlyRes: false,
    skipAuth: false,
    apiReqWithAuth: false,
    retries: DEFAULT_RETRIES,
    delay: 0,
  }
): Promise<T> {
  let retryCount = otherOptions?.retries;
  const { appVersion, platform, userAuth } = getUserData() as AnyObject;
  const request = {
    method: requestConfig?.method,
    body:
      requestConfig?.method !== "GET"
        ? requestConfig?.body && JSON.stringify(requestConfig?.body)
        : null,
    headers: {
      "Content-Type": "application/json",
      Authorization: userAuth,
      "client-type": platform,
      "app-version": appVersion,
      "RSA-ENCRYPTED-TOKEN": true,
      "X-SHARECHAT-CALLER": "pwa-moj-service",
      ...requestConfig?.headers,
    },
  };
  let response;
  if (typeof retryCount === "number") {
    try {
      while (!response?.ok && retryCount > 0) {
        if (retryCount !== otherOptions?.retries && otherOptions?.delay) {
          await wait(otherOptions?.delay);
        }
        await fetch(url, request)
          .then((res: Response) => (response = res))
          .catch((err: Response) => {
            response = {
              ok: false,
            };
          });
        retryCount -= 1;
      }
    } catch (err) {
      console.log(err);
    }
  } else {
    response = await fetch(url, request);
  }

  if (otherOptions.returnOnlyRes) {
    return response;
  }
  const resultJson = await response?.json();
  return resultJson;
}
